
import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-select',
    label: '分類',
    model: 'faqs_type_id',
    required: true,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/faq-type-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '標題',
    model: 'title',
    placeholder: '標題',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "內文",
    model: "content",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '是否開啟',
    model: 'enable',
    required: true,
    valueOn: 1,
    valueOff: 0,
  }
];

export default fields;
